import { privateApi } from 'services';
import { JobVacancy } from './types';

const fetchJobVacancies = async (
    jobGroupId: string,
    queryParams?: { [index: string]: string | string[] },
): Promise<JobVacancy[]> =>
    privateApi.get<JobVacancy[]>(`job-groups/${jobGroupId}/vacancies`, queryParams ? { params: queryParams } : null);

const fetchJobVacancy = async (JobVacancyId: string): Promise<JobVacancy> =>
    privateApi.get<JobVacancy>(`job-vacancies/${JobVacancyId}`);

export const JobVacancyGateway = {
    fetchJobVacancies,
    fetchJobVacancy,
};
